<div class="h-full bg-white p-6">
  <div class="grid w-full p-5">
    <span class="font-bold" translate> gestor-avaliacoes.alunos </span>
    <div class="flex justify-between">
      <span class="font-light" translate> gestor-avaliacoes.pendente-de-correcao </span>
      <app-switch [formControl]="selectPendingCtrl"></app-switch>
    </div>
    <label app-label translate> gestor-avaliacoes.filtro-turma-aluno </label>
    <ng-select
      app-select
      [formControl]="groupCtrl"
      [items]="groups$ | async"
      bindValue="id"
      bindLabel="description"
      [placeholder]="'geral.selecione' | translate"
      [loadingText]="'geral.carregando' | translate"
      [clearable]="false"
    >
    </ng-select>
  </div>
  <hr app-divider />
  <div *ngIf="studentsFiltered$ | async as students" class="px-1 pb-16 pt-0">
    <ng-container *ngIf="!!students.length; else emptyStudents">
      <app-card
        *ngFor="let student of students; let index = index"
        [id]="'user_' + student.usuario_id"
        (click)="onSetSelectedUser(student)"
        class="mb-1 mt-5 flex !flex-row items-center p-3 !shadow-black/25 hover:bg-base-whisper-300"
        [ngClass]="{
          '!active:border !br !active:border-solid !active:border-base-whisper-500 !bg-base-whisper-400 !shadow-inner !shadow-black/40':
            !!student.selected
        }"
      >
        <ng-container>
          <div class="w-3/12">
            <app-user-photo
              *ngIf="!!student.usuario_id; else imgIndexTemplate"
              class="h-auto !w-max md:!h-16"
              [height]="'!h-16'"
              [width]="'!w-max'"
              [src]="student.foto"
            ></app-user-photo>
            <ng-template #imgIndexTemplate>
              <div
                class="flex h-12 w-12 items-center justify-center rounded-full bg-theme-300 text-2xl font-semibold text-theme-700"
              >
                {{ index + 1 }}
              </div>
            </ng-template>
          </div>
          <div class="ml-5 grid w-full">
            <div class="flex justify-between gap-2">
              <span *ngIf="!!student.usuario_id; else emptyStudentTemplate" class="font-semibold">
                {{ student.nome }}
                <svg-icon
                  *ngIf="student.necessidades_especiais?.length"
                  app-tooltip
                  [tooltip]="onFormatSpecialNeeds(student.necessidades_especiais)"
                  class="active:brightness-85 inline-block h-6 w-6 cursor-pointer pt-1 text-gray-400 hover:brightness-110"
                  src="assets/icons/icon-info-rounded.svg"
                >
                </svg-icon>
              </span>
              <ng-template #emptyStudentTemplate>
                <div class="w-full">
                  <ng-select
                    app-select
                    [formControl]="unasignedCtrl"
                    [items]="studentsWithoutAttempt$ | async"
                    bindLabel="nome"
                    [notFoundText]="'geral.nao-encontrado' | translate"
                    [placeholder]="'eclass.selecione' | translate"
                  >
                  </ng-select>
                </div>
              </ng-template>

              <div class="flex items-center justify-end gap-2">
                <div *ngIf="student.loading" class="ml-2 flex h-6 w-6 items-center justify-center">
                  <app-skeleton class="flex h-4 w-4" [showLabel]="false"></app-skeleton>
                </div>
                <ng-container *ngIf="!!student.tentativa_uuid">
                  <button
                    app-flat-button
                    app-tooltip
                    *ngIf="!!student.usuario_id && !!student.tentativa_response_card_upload"
                    (click)="onRemoveStudent(student)"
                    tooltip="Desvincular aluno"
                    type="button"
                    class="bg-white"
                  >
                    <svg-icon
                      class="active:brightness-85 w-4 cursor-pointer text-base-status-info hover:brightness-110"
                      src="assets/icons/icon-copy-square.svg"
                    ></svg-icon>
                  </button>

                  <button
                    app-flat-button
                    app-tooltip
                    (click)="onRemoveAttempt(student)"
                    tooltip="Excluir respostas"
                    type="button"
                    class="bg-white"
                  >
                    <svg-icon
                      app-tooltip
                      class="active:brightness-85 hover w-4 cursor-pointer text-base-status-danger hover:brightness-110"
                      src="assets/icons/icon-trash.svg"
                    ></svg-icon>
                  </button>
                </ng-container>
              </div>
            </div>

            <div class="flex items-center gap-2">
              <span class="text-gray-500">{{ student.turma_descricao }}</span>
              <svg-icon
                *ngIf="onCheckIsOnline(student)"
                app-tooltip
                [tooltip]="'geral.online' | translate"
                class="h-5 w-5 text-gray-400"
                src="assets/icons/icon-video-session.svg"
              >
              </svg-icon>
            </div>
            <div *ngIf="onGetStatusLabel(student) as label" class="mt-2 flex">
              <span [ngClass]="label.class" class="rounded-full px-2 text-white">
                {{ label.text | translate }}
              </span>
            </div>
          </div>
        </ng-container>
        <ng-template #unasignedTemplate>
          <div class="w-3/12"></div>
          <div class="flex w-full flex-col gap-2">
            <div class="flex w-full items-center gap-4 font-bold"></div>
          </div>
        </ng-template>
      </app-card>
    </ng-container>
  </div>
</div>

<ng-template #emptyStudents>
  <app-card class="mt-5">
    <div app-card-content class="w-full">
      <app-jumbotron class="py-5">
        <span translate> gestor-avaliacoes.sem-alunos-correcao </span>
      </app-jumbotron>
    </div>
  </app-card>
</ng-template>
